import React from 'react';
import reviewsData from '../json/reviews.json';

const GoogleReviews = () => {
  // Function to truncate text
  const truncateText = (text, maxLength = 300) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  // Get first 15 reviews
  const limitedReviews = reviewsData.slice(0, 15);

  return (
    <div className="google-reviews-container">
      <div className="reviews-wrapper">
        {limitedReviews.map((review, index) => (
          <div key={index} className="review-card">
            <div className="review-header">
              <div className="review-author-info">
                <div className="author-avatar">
                  <span className="avatar-placeholder">
                    {review.author?.charAt(0) || 'H'}
                  </span>
                </div>
                <div className="author-details">
                  <h4>{review.author || 'Hazard County Customer'}</h4>
                  <p className="company-name">{review.company || ''}</p>
                  <div className="rating">
                    {[...Array(review.rating || 5)].map((_, i) => (
                      <span key={i} className="star">★</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <p className="review-text">
              {truncateText(review.review || review.text)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoogleReviews;